module.exports = __webpack_public_path__ + "img/6e8cb11ac4d27847d6241a86713bb91a.d2a7abce.png";